import { type Theme, alpha } from "@mui/material";

export const sharedShiftDialogPaperSx = (theme: Theme, isMobile: boolean) => ({
	borderRadius: isMobile ? 0 : 3,
	border: isMobile ? "none" : "1px solid",
	borderColor: alpha(theme.palette.divider, 0.9),
	overflow: "hidden",
	display: "flex",
	flexDirection: "column",
	backgroundColor: theme.palette.background.paper,
	backgroundImage: "none",
	maxHeight: isMobile ? "100%" : "min(88vh, 960px)",
	boxShadow: isMobile
		? "none"
		: `0 28px 90px ${alpha(
				theme.palette.common.black,
				theme.palette.mode === "dark" ? 0.42 : 0.18,
			)}`,
});

export const sharedShiftDialogHeaderSx = (theme: Theme) => ({
	borderBottom: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
	backgroundColor:
		theme.palette.mode === "dark"
			? alpha(theme.palette.common.white, 0.02)
			: alpha(theme.palette.common.black, 0.015),
});

export const sharedShiftDialogContentSx = (theme: Theme) => ({
	backgroundColor:
		theme.palette.mode === "dark"
			? alpha(theme.palette.common.black, 0.08)
			: alpha(theme.palette.common.black, 0.015),
	backgroundImage: "none",
});

export const sharedShiftDialogActionsSx = (
	theme: Theme,
	isMobile: boolean,
) => ({
	borderTop: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
	backgroundColor:
		theme.palette.mode === "dark"
			? alpha(theme.palette.common.white, 0.02)
			: alpha(theme.palette.common.black, 0.015),
	...(isMobile
		? {
				position: "sticky" as const,
				bottom: 0,
				backdropFilter: "blur(10px)",
			}
		: {}),
});

export const sharedShiftDialogPanelSx = (theme: Theme) => ({
	border: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
	borderRadius: 2.5,
	backgroundColor:
		theme.palette.mode === "dark"
			? alpha(theme.palette.common.white, 0.025)
			: alpha(theme.palette.common.white, 0.9),
	boxShadow: `inset 0 1px 0 ${alpha(
		theme.palette.common.white,
		theme.palette.mode === "dark" ? 0.04 : 0.5,
	)}`,
});
